import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { HasSlotController } from '../../helpers';
import { styles, tag } from './card.styles';

@customElement(tag)
export class CardComponent extends TmElement {
  static override styles = styles;

  private readonly hasSlotController = new HasSlotController(
    this,
    'footer',
    'header',
    'image',
  );

  override render() {
    return html`
      <div
        part="container"
        class=${classMap({
          'has-footer': this.hasSlotController.test('footer'),
          'has-header': this.hasSlotController.test('header'),
          'has-image': this.hasSlotController.test('image'),
          [tag]: true,
        })}
      >
        <header part="header" data-test="cardHeader">
          <slot name="image" data-test="cardHeaderImage"></slot>
          <slot name="header" data-test="cardHeaderHeader"></slot>
        </header>
        <main part="main">
          <slot data-test="cardMain"></slot>
        </main>
        <footer part="footer">
          <slot name="footer" data-test="cardFooter"></slot>
        </footer>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-card': CardComponent;
  }
}
